const getImageLogosSrcSet = (path) => {
  return {
    src: `${path}?tr=w-160,f-auto,q-auto`,
    srcSet: `
      ${path}?tr=w-80,f-auto,q-auto 80w,
      ${path}?tr=w-120,f-auto,q-auto 120w,
      ${path}?tr=w-160,f-auto,q-auto 160w,
      ${path}?tr=w-240,f-auto,q-auto 240w,
      ${path}?tr=w-320,f-auto,q-auto 320w
    `,
    sizes: `(max-width: 640px) 100px, (max-width: 1024px) 140px, 10vh`,
    // If screen width ≤ 640px
    // Image will display at ~100px wide

    // If screen width ≤ 1024px
    // Image will display at ~140px wide

    // For anything larger than 1024px
    // Image will display at ~180px wide
  };
}

export default getImageLogosSrcSet;